export function qualMargem (beneficio) {
  let margem = beneficio.margem_consig
  if (beneficio.data_margem_consig_online && (beneficio.margem_consig_online || beneficio.margem_consig_online === 0)) {
    let dataRetro = new Date()
    dataRetro.setDate(dataRetro.getDate() - 7)
    let dataVal = new Date(beneficio.data_margem_consig_online)
    if (dataVal >= dataRetro) margem = beneficio.margem_consig_online
  }
  return margem
}



// WEBPACK FOOTER //
// ./src/service/pedido.js